//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data(){
        return {
            info:'',
            form: {
                oldMobile:'',
                mobile: '',
                smsCode: ''
            },
            size:'normal',
            shows: true, //获取验证码展示 false 倒计时
            count: '', //验证码倒计时
            disable: false,  //控制验证码不能短期请求多次
            timer: '',
            sms:{
                phone:'',
                type:3 //修改手机号
            }
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
         //获取个人信息
        getInfo(){
            this.$get('/sys/user/info','',function(res){
                if(res.code==200){
                    this.info=res.data;
                    this.form.oldMobile = res.data.userAuth.identifier
                }
            })
        },
        // 获取验证码
        getverificationcode(){
             if (this.disable == true) {
                return;
            }
            this.sms.phone=this.form.oldMobile
            this.$get(`/sys/user/sms`,this.sms,function(res){
                if(res.code==200){
                    this.$message.success('验证码已发送!')
                    this.disable = true;
                    const TIME_COUNT = 120;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.shows = false;
                        this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.shows = true;
                            clearInterval(this.timer);
                            this.disable = false;
                            this.timer = null;
                        }
                        }, 1000)
                    }
                }else{
                    this.$message.error(res.msg)
                }
            })
        },

        /*保存手机号*/
        saveData: function () {
            if(this.form.mobile==this.form.oldMobile){
                this.$message.error('新手机号与旧手机号不能相同');
                return
            }
            this.$put('/sys/user/modify/mobile',this.form,function(res){
                if(res.data==true){
                    this.$message.success('修改成功!')
                    setTimeout(() => {
                        this.$router.back(-1);
                    }, 1000);
                }else{
                    this.$message.error(res.msg)
                }
            },true)
        },

    }
}
